import { Badge } from '@repo/web-ui/components/badge/badge'
import { useTranslations } from 'next-intl'

export const SourceBadge = () => {
  const t = useTranslations('components.product_box')

  return (
    <Badge className="absolute bottom-2 right-2" variant="purple">
      {t('source_message')}
    </Badge>
  )
}
